export const DatePickerDefaultRanges = {
  last7Days: '-7',
  TODAY: 'today',
  YESTERDAY: 'yesterday',
  last30Days: '-30',
  LAST_MONTH: 'lastmonth',
  THIS_MONTH: 'thismonth',
  ALL: 'allTime',
  CUSTOM: 'custom',
};
